import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
    label: string;
    to?: string;
}

interface AIPurchaseBreadcrumbsProps {
    items: BreadcrumbItem[];
}

/**
 * Breadcrumb trail for the AI Purchase Numbers pages, using real `<Link>`s back up
 * the hierarchy (matches the pattern used in `CreateMicrosite.tsx`/`CreateBlog.tsx`).
 * The last item is rendered as plain text (current page).
 */
export default function AIPurchaseBreadcrumbs({ items }: AIPurchaseBreadcrumbsProps) {
    return (
        <div className="flex items-center gap-2 text-sm text-[#64748b] flex-wrap">
            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                    <span key={`${item.label}-${index}`} className="flex items-center gap-2">
                        {item.to && !isLast ? (
                            <Link to={item.to} className="hover:text-[#6e64f0] transition-colors">
                                {item.label}
                            </Link>
                        ) : (
                            <span className="text-[#1e293b] font-medium">{item.label}</span>
                        )}
                        {!isLast && <span>/</span>}
                    </span>
                );
            })}
        </div>
    );
}
